// extracted by mini-css-extract-plugin
export default {"valueContainer":"resultValues_valueContainer__eYXKz","value":"resultValues_value__6RQTt"};